import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Explore from "../pages/explore/page";
import CreateRoute from "../pages/create-route/page";
import MyTrips from "../pages/my-trips/page";
import PlaceDetail from "../pages/place/page";
import RouteResult from "../pages/route-result/page";
import SharePage from "../pages/share/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/explore",
    element: <Explore />,
  },
  {
    path: "/create-route",
    element: <CreateRoute />,
  },
  {
    path: "/my-trips",
    element: <MyTrips />,
  },
  {
    path: "/place/:id",
    element: <PlaceDetail />,
  },
  {
    path: "/route-result",
    element: <RouteResult />,
  },
  {
    path: "/share",
    element: <SharePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;